import React from "react";

export default function PricePlan() {
  return (
    <div className="shadow-lg mb-5 bg-white rounded">
      <div className="primaryBgColor colorWhite h4 text-center pt-3 pb-3 mb-0 rounded-top">
        Payment Plans
      </div>
      <div className="table-responsive rounded border">
        <table className="table colorBgWhite">
          <thead>
            <tr>
              <th>Athlete</th>
              <th>Price</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>0-3</td>
              <td>Free</td>
            </tr>
            <tr>
              <td>4-25</td>
              <td>$25</td>
            </tr>
            <tr>
              <td>25+</td>
              <td>$46</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
